import { ScreenHeading, VidaLogo } from '@/modules/ui';

type AccountHeaderProps = {
  title: string;
  subtitle: string;
};

// Shared masthead for the account-creation flows: logo + title/subtitle. Submit
// errors are a per-flow concern (some surface them on a field, others as a
// banner), so each screen renders its own.
export function AccountHeader({ title, subtitle }: AccountHeaderProps) {
  return (
    <>
      <VidaLogo width={112} height={29} />

      <ScreenHeading title={title} subtitle={subtitle} />
    </>
  );
}
